/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { TranslocoService } from '@ngneat/transloco';

const CONTENT_CARD_TYPE_LABEL_KEYS: Record<string, string> = {
  RESOURCE: 'translations.contentCard.type.card',
  CARD: 'translations.contentCard.type.card',
  EVENT: 'translations.contentCard.type.event',
  ASSESSMENT: 'translations.contentCard.type.assessment',
  PERSONALITY_INDICATOR: 'translations.contentCard.type.persona',
  WEBLINK: 'translations.contentCard.type.link',
  COURSE: 'translations.contentCard.type.course',
  LTI_COURSE: 'translations.contentCard.type.course',
  PROGRAM: 'translations.contentCard.type.programme',
  MODULE: 'translations.contentCard.type.programme',
  STANDARD: 'translations.contentCard.type.collection',
  COLLECTION: 'translations.contentCard.type.collection',
  PLAYLIST: 'translations.contentCard.type.collection',
  SCORM: 'translations.contentCard.type.scorm',
};

export function contentCardTypeLabelKey(...types: (string | null | undefined)[]): string | null {
  for (const type of types) {
    if (!type) {
      continue;
    }
    const key = CONTENT_CARD_TYPE_LABEL_KEYS[type.toUpperCase()];
    if (key) {
      return key;
    }
  }
  return null;
}

export function contentCardTypeLabel(transloco: TranslocoService, ...types: (string | null | undefined)[]): string {
  const key = contentCardTypeLabelKey(...types);
  if (key) {
    return transloco.translate(key);
  }
  const rawType = types.find((type) => !!type);
  return rawType ? rawType.charAt(0).toUpperCase() + rawType.slice(1).toLowerCase() : '';
}
